export const getUserName = () => {
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj?.data?.user_name
  }
}
export const getFirstname = () => {
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj?.data?.firstName
  }
}

export const getUserNames = () => {
  if (localStorage.getItem("authUsers")) {
    const obj = JSON.parse(localStorage.getItem("authUsers"))
    return obj?.username
  }
}
export const getMailID = () => {
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj?.data?.email
  }
}

export const getDateFormateMethod = () => {
  let today = new Date()
  const dd = today.getDate().toString()
  const mm = today.getMonth() + 1
  const yyyy = today.getFullYear()
  const fromate_date = (today = dd + "/" + mm + "/" + yyyy)
  return fromate_date
}

export const getAuthorizationToken = () => {
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj?.token
  }
}

export const commonHide_show = JSON.parse(
  localStorage.getItem("authUser") || "{}"
)?.data

export const getUserID = () => {
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj?.data?.id
  }
}